import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

export const SUPPORTED_LANGUAGES = ['ru', 'en', 'kk', 'uz'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    // ru-RU, en-US, kk-KZ, uz-UZ приходят к ru, en, kk, uz
    load: 'languageOnly',
    detection: {
      // при первом входе язык берём из браузера, дальше — выбор пользователя
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
      // en-GB → en: храним и показываем короткий код
      convertDetectedLanguage: (lng) => lng.split('-')[0],
    },
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
